import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import * as Fetch from '@/service/fetch'
import selfFunc from '@/utils/common'
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import './assets/css/index.css'

Vue.use(ElementUI);

//ECharts
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.prototype.$http = Fetch

Vue.prototype.$selfFunc = selfFunc

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount("#app");